import request from '@/assets/js/request';

/**
 * AI封面愿望单
 * @param {Number} estimatedProductTime 预计制作时间
 */
export function aiCoverWishlist(estimatedProductTime) {
    return request({
        url: '/ai/wishlistSubmit',
        method: 'POST',
        data: { estimatedProductTime },
        formData: false
    });
}